import smartSolveApi from './instances/smartsolve';

export const getProductHierarchy = async (params) => {
  try {
    const { itmId, entityName } = params;

    const response = await smartSolveApi.post('/getHierarchy', {
      itmId,
      entityName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getProductHierarchy() failed: ${e}`);
  }
};

export const getHierarchyChildren = async (params) => {
  try {
    const { itmId, entityName, currentPageIndex, pageSize, filter } = params;

    const response = await smartSolveApi.post('/getHierarchyChildren', {
      itmId,
      entityName,
      currentPageIndex,
      pageSize,
      filter,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getHierarchyChildren() failed: ${e}`);
  }
};
